import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy, RouterStateSnapshot } from '@angular/router';

export class DefaultRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {}

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {
    // do nothing
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // avoid reusing the same component if the slug is different for movie pages

    const currState = (curr as any)._routerState as RouterStateSnapshot;

    const futState = (future as any)._routerState as RouterStateSnapshot;

    if (currState.url.startsWith('/movie/') && futState.url.startsWith('/movie/')) {
      const currSlug = currState.url.split('/').pop().split(/[?#]/)[0];

      const futSlug = futState.url.split('/').pop().split(/[?#]/)[0];

      return currSlug === futSlug;
    }

    // default

    return future.routeConfig === curr.routeConfig;
  }
}

export const providerRouteReuseStrategy = () => {
  return {
    provide: RouteReuseStrategy,

    useClass: CustomRouteReuseStrategy
  };
};
